var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { GroupSearch } from './group-search';
var InfluencerSearch = /** @class */ (function (_super) {
    __extends(InfluencerSearch, _super);
    function InfluencerSearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.audienceFilters = [];
        return _this;
    }
    return InfluencerSearch;
}(GroupSearch));
export { InfluencerSearch };



// WEBPACK FOOTER //
// ./src/models/influencer-search.ts.pre-build-optimizer.js